export const painPoints = [
  'Searching for ideas every week, then still having to turn them into a session.',
  'Repeating the same games because there is no time to plan something new.',
  'Finding a great activity without the instructions, materials or printables it needs.',
  'Guessing how to fill 45 minutes and what should happen next.',
  'Changing the plan at the last minute when space or supplies are limited.',
  'Finishing one encounter and immediately wondering what to do next week.',
];

export const comparisonRows = [
  { before: 'Search for a new idea every week', after: 'Open the next weekly session' },
  { before: 'Choose games and work out the order', after: 'Follow the prepared activity sequence' },
  { before: 'Guess quantities and setup', after: 'Check the materials list and space plan' },
  { before: 'Write instructions and invent resources', after: 'Use the scripts and included resources' },
  { before: 'Start again when the group needs a change', after: 'Choose a supplied adaptation' },
];
